"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Headset, House, ShoppingBag, UserRound } from "lucide-react";
import { usePathname } from "next/navigation";
import { useCart } from "@/store/shipping-cart/useCart";
import { useAuthStore } from "@/store/auth/authStore";

function NavigationBar() {
    const pathname = usePathname();
    const [showNavigation, setShowNavigation] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const { token } = useAuthStore();
    const { items } = useCart();
    const activeItems = Array.isArray(items) ? items.filter((item) => item?.active) : [];

    useEffect(() => {
        setIsMounted(true);
        const hiddenPaths = ["/profile/ticket/", "/auth"];
        if (hiddenPaths.some((path) => pathname.startsWith(path))) {
            setShowNavigation(true);
        } else {
            setShowNavigation(false);
        }
    }, [pathname]);

    if (showNavigation) return null;

    return (
        <div
            className="w-full md:hidden z-[45] flex bg-white fixed bottom-0 left-0 flex-wrap h-[71px]"
            style={{ boxShadow: "-2px -4px 20px 0px rgba(0, 0, 0, 0.05)" }}
        >
            <Link
                prefetch={false}
                href={"/"}
                className={`w-1/4 flex flex-wrap content-center gap-y-1 justify-center h-full duration-200 ${
                    pathname === "/" && "text-orange-primary"
                }`}
            >
                <House className="w-6 h-6" />
                <div className="w-full flex items-center justify-center text-xs font-medium">خانه</div>
            </Link>
            <Link
                prefetch={false}
                href={"/shopping-bag"}
                className={`w-1/4 flex flex-wrap relative content-center gap-y-1 justify-center h-full ${
                    pathname === "/shopping-bag" && "text-orange-primary"
                }`}
            >
                <ShoppingBag className="w-6 h-6" />
                <div className="w-full flex items-center justify-center text-xs font-medium">
                    سبد خرید
                    {activeItems?.length > 0 && (
                        <span className="flex items-center absolute right-5 top-2 justify-center w-[16px] h-[16px] rounded-full bg-orange-primary text-[8px] font-extrabold text-white">
                            {activeItems?.length?.toLocaleString("fa")}
                        </span>
                    )}
                </div>
            </Link>
            {isMounted ? (
                token ? (
                    <Link
                        prefetch={false}
                        href={"/profile"}
                        className={`w-1/4 flex flex-wrap content-center gap-y-1 justify-center h-full ${
                            pathname.search("/profile") > -1 && "text-orange-primary"
                        }`}
                    >
                        <UserRound className="w-6 h-6" />
                        <div className="w-full flex items-center justify-center text-xs font-medium">پروفایل</div>
                    </Link>
                ) : (
                    <Link
                        prefetch={false}
                        href={"/auth"}
                        className={`w-1/4 flex flex-wrap content-center gap-y-1 justify-center h-full ${
                            pathname.search("/profile") > -1 && "text-orange-primary"
                        }`}
                    >
                        <UserRound className="w-6 h-6" />
                        <div className="w-full flex items-center justify-center text-xs font-medium">پروفایل</div>
                    </Link>
                )
            ) : (
                <div className="w-1/4 flex flex-wrap content-center gap-y-1 justify-center h-full">
                    <UserRound className="w-6 h-6" />
                    <div className="w-full flex items-center justify-center text-xs font-medium">پروفایل</div>
                </div>
            )}
            <Link
                prefetch={false}
                href={"/contact-us"}
                className={`w-1/4 flex flex-wrap content-center gap-y-1 justify-center h-full ${
                    pathname === "/contact-us" && "text-orange-primary"
                }`}
            >
                <Headset className="w-6 h-6" />
                <div className="w-full flex items-center justify-center text-xs font-medium">پشتیبانی</div>
            </Link>
        </div>
    );
}

export default NavigationBar;